import React, { memo } from 'react';

import { CallToActionSideBlock } from '@sravni/react-ugc/lib/CallToActionSideBlock';
import { getOrganizationHelpers } from '@sravni/ugc/lib/organizations/helpers';
import { OrganizationTypes } from '@sravni/ugc/lib/organizations/types';
import type { OrganizationType } from '@sravni/utils/lib/createReviewLink';
import { createReviewLink } from '@sravni/utils/lib/createReviewLink';

import { sendGoToWriteReviewEvent } from '../../helpers/analyticsEvents';
import { useFilters } from '../../store/hooks/filters';

const textMap = {
  [OrganizationTypes.Bank]: 'Расскажите о своём опыте использования банковских услуг',
  [OrganizationTypes.Insurance]: 'Расскажите о своём опыте использования страховых услуг',
  [OrganizationTypes.Mfo]: 'Расскажите о своём опыте использования услуг микрофинансовых организаций',
  [OrganizationTypes.EducationalOrganization]: 'Расскажите о своём опыте обучения',
  [OrganizationTypes.Broker]: 'Расскажите о своём опыте использования брокерских услуг',
  [OrganizationTypes.Npf]: 'Расскажите о своём опыте использования негосударственных пенсионных фондов',
  [OrganizationTypes.Bankruptcy]: 'Расскажите о своем опыте использования услуг по банкротству физических лиц',
  [OrganizationTypes.Bookmaker]: 'Расскажите о своём опыте использования букмекерских услуг',
  [OrganizationTypes.University]: 'Расскажите о своём опыте обучения',
  [OrganizationTypes.FoodRation]: 'Расскажите о своём опыте использования услуг сервисов готовых рационов',
};

export const GiveFeedback = memo(() => {
  const { organizationType } = useFilters();

  const handleClick = () =>
    sendGoToWriteReviewEvent({
      organizationType,
    });

  const organizationHelper = getOrganizationHelpers(organizationType);

  const link = createReviewLink({
    organizationType: (organizationHelper.oldOrgType ?? organizationHelper.typeForService) as OrganizationType,
  });

  return (
    <CallToActionSideBlock
      title="Оставить отзыв"
      text={textMap[organizationType]}
      buttonLabel="Написать отзыв"
      handleClick={handleClick}
      link={link}
    />
  );
});
